import { LLMPricingEntry } from '../types/admin';

/**
 * Calculate raw provider cost in dollars for a model's token usage.
 * Prices are per 1M tokens.
 */
export function calculateModelCost(
  inputTokens: number,
  outputTokens: number,
  cachedInputTokens: number | null,
  pricing: LLMPricingEntry,
): number {
  const inputCost = (inputTokens / 1_000_000) * pricing.input_price;
  const outputCost = (outputTokens / 1_000_000) * pricing.output_price;

  let cacheCost = 0;
  if (cachedInputTokens && cachedInputTokens > 0) {
    const cachePrice = pricing.cache_read_price ?? pricing.input_price;
    cacheCost = (cachedInputTokens / 1_000_000) * cachePrice;
  }

  return inputCost + outputCost + cacheCost;
}

/** Format dollar amount: $0.0042, $1.23, $12.50 */
export function formatCost(dollars: number): string {
  if (dollars === 0) return '$0.00';
  if (dollars < 0.01) return `$${dollars.toFixed(4)}`;
  return `$${dollars.toFixed(2)}`;
}
